var map = {
	"./arrow-down.svg": 643,
	"./arrow-left.svg": 644,
	"./arrow-right.svg": 645,
	"./arrow-up.svg": 646,
	"./close.svg": 647,
	"./download.svg": 648,
	"./email.svg": 649,
	"./embed.svg": 650,
	"./expand.svg": 651,
	"./facebook-alt.svg": 652,
	"./facebook.svg": 653,
	"./film.svg": 654,
	"./fullscreen.svg": 655,
	"./grid.svg": 656,
	"./instagram-alt.svg": 657,
	"./instagram.svg": 658,
	"./interactive.svg": 659,
	"./linkedin.svg": 660,
	"./lock.svg": 661,
	"./photographs.svg": 662,
	"./play.svg": 663,
	"./plus.svg": 664,
	"./share.svg": 665,
	"./spinner.svg": 666,
	"./twitter-alt.svg": 667,
	"./twitter.svg": 668,
	"./vimeo-alt.svg": 669,
	"./vimeo.svg": 670
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 807;


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons \.svg$
// module id = 807
// module chunks = 1474